<div (click)="openSummaryModal()" class="widget-container">
  <div
    *ngFor="let i of data; trackById"
    class="btn-tool"
    style="cursor: pointer"
  >
    <div class="box" [style.backgroundColor]="i.color">
      {{ i.value }}
    </div>
    <span
      class="tooltip-text"
      style="margin-top: -5.3em; margin-left: -0.5em"
      >{{ i.name }}</span
    >
    <!-- <div class="box" [class]="getBgColor(i.severity_level)">
      {{ i.value }}
    </div> -->
  </div>
</div>
